// Section Separator
document.addEventListener('DOMContentLoaded', () => {
  const separatorSections = document.querySelectorAll('[data-section-type="w-separator"]');

  separatorSections.forEach(section => {
    // Initialization if needed
  });
});
